import { connect } from 'react-redux'
import { createModifiedCounterPartySelector } from 'selectors/negotiations'
import { GlobalState } from 'store'
import { PivotedRowGroupedColumnHeaderComponent } from '../LiveNegotiationsGrid/PivotedRowGroupedColumnHeaderRenderer'

interface GridCounterPartyHeaderProps extends PivotedRowGroupedColumnHeaderComponent {
  counterpartyId: string
}

export const GridCounterPartyHeader = connect((state: GlobalState, props: GridCounterPartyHeaderProps) => ({
  isModifiedValues: createModifiedCounterPartySelector(props.counterpartyId)(state)
}))(PivotedRowGroupedColumnHeaderComponent)
